import { z } from "zod";

import {
  insertCampusesTypeSchema,
  publicCampusStatusEnumSchema,
  rowCampusesTypeSchema,
  updateCampusesTypeSchema,
} from "@libs/schemas";

export const campusSchema = rowCampusesTypeSchema;
export type CampusType = z.infer<typeof campusSchema>;

export type CampusStatusType = z.infer<typeof publicCampusStatusEnumSchema>;

export type CampusInsertType = z.infer<typeof insertCampusesTypeSchema>;
export type CampusUpdateType = z.infer<typeof updateCampusesTypeSchema>;

export const campusesRelationSchema = z.object({
  campuses: z
    .array(
      rowCampusesTypeSchema
        .pick({
          id: true,
          name: true,
          short_code: true,
          province: true,
        })
        .partial({
          province: true,
          short_code: true,
        }),
    )
    .optional()
    .catch([]),
});

export const campusesIdsSchema = z.object({
  campusesIds: z.array(z.string()).nullable(),
});
